import { render } from "./UnAuthorizedPage.vue?vue&type=template&id=0635aab8&scoped=true"
import script from "./UnAuthorizedPage.vue?vue&type=script&lang=js"
export * from "./UnAuthorizedPage.vue?vue&type=script&lang=js"

import "./UnAuthorizedPage.vue?vue&type=style&index=0&id=0635aab8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0635aab8"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QPageContainer,QPage,QBtn});
